// 用户列表
export const tableColumns = [
  {
    key: 1,
    title: '用户id',
    filed: 'userId',
    width: 180
  },
  {
    key: 2,
    title: '电话',
    filed: 'phone',
    width: 180
  },
  {
    key: 3,
    title: '注册时间',
    filed: 'registerDate',
    width: 180
  },
  {
    key: 4,
    title: '会员等级',
    filed: 'memberLevelName'
  },
  {
    key: 5,
    title: '用户来源',
    filed: 'userSource'
  },
  {
    key: 6,
    title: '标签',
    filed: 'tags'
  },
  {
    key: 7,
    title: '订单数(已完成)',
    filed: 'orderNumber'
  },
  {
    key: 8,
    title: '订单金额(已完成)',
    filed: 'orderAmount'
  }
]
// 积分明细列表
export const scoreStatisticsTableColumns = [
  {
    key: 1,
    title: '时间',
    filed: 'createTime',
    width: 180
  },
  {
    key: 2,
    title: '类型',
    filed: 'typeName',
    width: 180
  },
  {
    key: 3,
    title: '收支数量',
    filed: 'quantity',
    width: 180
  },
  {
    key: 4,
    title: '剩余积分',
    filed: 'balance',
    width: 180
  },
  {
    key: 5,
    title: '收支原因',
    filed: 'remark'
  }
]
// 成长值明细列表
export const growthStatisticsTableColumns = [
  {
    key: 1,
    title: '时间',
    filed: 'createTime',
    width: 180
  },
  {
    key: 2,
    title: '增长数量',
    filed: 'quantity',
    width: 180
  },
  {
    key: 3,
    title: '剩余成长值',
    filed: 'balance',
    width: 180
  },
  {
    key: 4,
    title: '收支原因',
    filed: 'remark'
  }
]
